
import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_tenant_budget_allocations: { message: "idle" },
};

export const retrieve_tenant_budget_allocations_Slice = createSlice({
 name: "retrieve_tenant_budget_allocations",
 initialState,
 reducers: {
  success_retrieve_tenant_budget_allocations: (state, action) => {
   state.retrieve_tenant_budget_allocations = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_tenant_budget_allocations: (state, action) => {
   state.retrieve_tenant_budget_allocations = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_tenant_budget_allocations: (state) => {
   state.retrieve_tenant_budget_allocations = { status: app_consts.IDLE };
  },
  loading_retrieve_tenant_budget_allocations: (state) => {
   state.retrieve_tenant_budget_allocations = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_tenant_budget_allocations, fail_retrieve_tenant_budget_allocations, reset_retrieve_tenant_budget_allocations, loading_retrieve_tenant_budget_allocations } = retrieve_tenant_budget_allocations_Slice.actions;

export default retrieve_tenant_budget_allocations_Slice.reducer;